export default __webpack_public_path__ + "static/media/healthbackground-hexagon.f117e55d.png";